/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom, Subject} from 'rxjs';
import {Component, Inject, OnInit, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import * as _ from 'lodash';
import {completeCopyModal} from '../../common/util/complete-copy-modal';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './user-copy-modal.component.html';
import {nextCopyTitle} from '../../../components/util/next-copy-title';
import {Uuid} from '../../../components/util/uuid';
import {UserApiService} from './user-api.service';
import {AppSharedModule} from '../../common/app-shared.module';

export interface UserCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: true,
  imports: [AppSharedModule, FormsModule],
  selector: 'adn-user-copy-modal',
  template
})
export class UserCopyModalComponent implements OnInit {
  model: any;

  readonly onCopied = new Subject<UserCopyResult>();

  originalName = '';
  username = '';
  name = '';
  displayName = '';
  password = '';
  destination = true;
  readonly pending = signal(false);
  readonly validationErrors = signal<any[]>([]);

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(UserApiService) private readonly User: UserApiService
  ) {
  }

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.displayName = nextCopyTitle(this.model?.displayName || '');
    this.username = '';
  }

  copy(): void {
    if (this.pending()) {
      return;
    }

    this.pending.set(true);
    this.validationErrors.set([]);

    const copyData = _.cloneDeep(this.model);
    copyData.id = Uuid.generate();
    copyData.name = this.name;
    copyData.displayName = this.displayName;
    copyData.username = this.username;
    copyData.password = this.password;

    firstValueFrom(this.User.save(copyData)).then((saved: any) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    }, (errors: any) => {
      this.validationErrors.set((errors && errors.data && errors.data.errors) || []);
      this.pending.set(false);
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
